import { defineMessages } from 'react-intl'

export default defineMessages({
  all: {
    id: 'All',
    defaultMessage: 'All'
  },
  parentNotificationId: {
    id: 'OrganizationAuditPage.ParentNotificationId',
    defaultMessage: 'Correlation Id'
  },
  parentNotificationIdPlaceholder: {
    id: 'OrganizationAuditPage.ParentNotificationId.Placeholder',
    defaultMessage: 'Enter Id'
  },
  end: {
    id: 'End',
    defaultMessage: 'End'
  },
  event: {
    id: 'OrganizationAuditPage.Event',
    defaultMessage: 'Event Type'
  },
  details: {
    id: 'Details',
    defaultMessage: 'Details'
  },
  audit: {
    id: 'OrganizationAuditPage.AuditLogs',
    defaultMessage: 'Search audit logs by:'
  },
  orgAuditLogs: {
    id: 'OrganizationAuditPage.AuditLogs.Description',
    defaultMessage: 'Organization Audit Logs'
  },
  noLogs: {
    id: 'OrganizationAuditPage.NoLogs',
    defaultMessage: 'There are no audit log records found for the selected filters.'
  },
  fetchingLogs: {
    id: 'OrganizationAuditPage.FetchingLogs',
    defaultMessage: 'Fetching Audit Logs...'
  },
  start: {
    id: 'Start',
    defaultMessage: 'Start'
  },
  user: {
    id: 'OrganizationAuditPage.User',
    defaultMessage: 'User'
  },
  userPlaceholder: {
    id: 'OrganizationAuditPage.User.Placeholder',
    defaultMessage: 'Name or Email'
  },
  noMatchingEvents: {
    id: 'OrganizationAuditPage.Event.NoMatch',
    defaultMessage: 'No matching event.'
  },
  name: {
    id: 'Name',
    defaultMessage: 'Name'
  },
  type: {
    id: 'Type',
    defaultMessage: 'Type'
  },
  eventDetails: {
    id: 'OrganizationAuditPage.Event.EventDetails',
    defaultMessage: 'Event Details'
  },
  eventDetailsHolder: {
    id: 'OrganizationAuditPage.Event.EventDetails.Placeholder',
    defaultMessage: 'Enter text'
  }
})
